import { render, staticRenderFns } from "./SingleCityFeatures.vue?vue&type=template&id=132a41c0&scoped=true"
import script from "./SingleCityFeatures.vue?vue&type=script&lang=js"
export * from "./SingleCityFeatures.vue?vue&type=script&lang=js"
import style0 from "./SingleCityFeatures.vue?vue&type=style&index=0&id=132a41c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a41c0",
  null
  
)

export default component.exports